module.exports = __webpack_public_path__ + "img/user-plus-01.29e4be63.svg";